import i18n from "i18n";

/**
 * Storing the current Feedback Status Type property options
 */
const FeedbackStatusTypes = {
	get O() {
		return i18n.t("label.outstanding");
	},
	get C() {
		return i18n.t("label.complete");
	},
};

export default FeedbackStatusTypes;
